import React from 'react'
import { motion } from 'framer-motion'

const ImageGallerySection: React.FC = () => {
  // High-quality lifestyle and home images from Unsplash that fit Hudson Club aesthetic
  const galleryImages = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop&crop=center",
      alt: "Luxury living room with modern furnishings",
      category: "Interior Design"
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400&h=400&fit=crop&crop=center",
      alt: "Elegant kitchen with marble countertops",
      category: "Kitchen Design"
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop&crop=center",
      alt: "Beautiful home exterior with landscaping",
      category: "Home Exterior"
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1560448075-bb485b067938?w=400&h=400&fit=crop&crop=center",
      alt: "Sophisticated bedroom with neutral tones",
      category: "Bedroom Design"
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=400&h=400&fit=crop&crop=center",
      alt: "Modern home office with clean lines",
      category: "Home Office"
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=400&h=400&fit=crop&crop=center",
      alt: "Stunning bathroom with luxury fixtures",
      category: "Bathroom Design"
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=400&fit=crop&crop=center",
      alt: "Cozy reading nook with natural lighting",
      category: "Living Spaces"
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=400&h=400&fit=crop&crop=center",
      alt: "Elegant dining room setup",
      category: "Dining Room"
    },
    {
      id: 9,
      src: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=400&h=400&fit=crop&crop=center",
      alt: "Beautiful garden and outdoor space",
      category: "Outdoor Living"
    },
    {
      id: 10,
      src: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=400&h=400&fit=crop&crop=center",
      alt: "Luxury home entrance and foyer",
      category: "Entryway"
    },
    {
      id: 11,
      src: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=400&h=400&fit=crop&crop=center",
      alt: "Modern fireplace and living area",
      category: "Living Room"
    },
    {
      id: 12,
      src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?w=400&h=400&fit=crop&crop=center",
      alt: "Premium home amenities",
      category: "Home Features"
    }
  ]

  return (
    <section 
      className="relative overflow-hidden"
      style={{ 
        backgroundColor: 'rgb(246, 246, 241)', // Exact Figma background
        height: '300px'
      }}
    >
      <div className="relative max-w-[1200px] mx-auto h-full">
        
        {/* Gallery Container */}
        <div className="relative h-full flex items-center justify-center px-4">
          
          {/* Scrollable Gallery */}
          <div 
            className="flex gap-2 overflow-x-auto py-12 px-4"
            style={{
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
              WebkitScrollbar: { display: 'none' }
            } as React.CSSProperties}
          >
            <div className="flex gap-2 min-w-max">
              {galleryImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.05 }}
                  whileHover={{ scale: 1.05, zIndex: 10 }}
                  className="relative group cursor-pointer flex-shrink-0"
                  style={{ width: '200px', height: '200px' }}
                >
                  <div className="w-full h-full rounded-lg overflow-hidden shadow-md transition-all duration-300 group-hover:shadow-xl">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                      loading="lazy"
                    />
                    
                    {/* Overlay on hover */}
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-end">
                      <div className="p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                        <p className="text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          {image.category}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Gradient fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[rgb(246,246,241)] to-transparent pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[rgb(246,246,241)] to-transparent pointer-events-none"></div>
        </div>

        {/* Optional: Section title overlay (can be uncommented if needed) */}
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center opacity-80 pointer-events-none">
          <h3 
            className="text-sm font-medium tracking-wide"
            style={{ color: 'rgb(30, 29, 28)' }}
          >
            Our Portfolio
          </h3>
        </div>
      </div>


    </section>
  )
}

export default ImageGallerySection 